<template>
  <div class="height100 flex flex-col">
    <div class="bg-fff margin-bottom-10">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18 font-bold">用户管理</div>
        <div>
          <el-button type="primary" size="small" @click="dialogVisible=true">
            <i class="el-icon-plus" style="margin-right: 5px"></i>添加用户
          </el-button>
        </div>
      </div>
      <div class="global-line"></div>
<!--      <div class="global-padd-15">-->
<!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
<!--          <el-tab-pane label="资质已审核" name="first"></el-tab-pane>-->
<!--          <el-tab-pane label="资质未审核" name="second"></el-tab-pane>-->
<!--        </el-tabs>-->
<!--      </div>-->
      <div class="global-padd-15">
        <el-form v-model="form" inline>
          <el-form-item label="状态：">
              <el-select size="small"
                         clearable
                         style="width: 180px"
                         v-model="form.userStatus">
                  <el-option label="启用" :value="0" ></el-option>
                  <el-option label="禁用" :value="1" ></el-option>

              </el-select>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input size="small"
                      style="width: 180px"
                      clearable
                      v-model="form.name"
                      placeholder="姓名">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input size="small"
                      style="width: 180px"
                      type="number"
                      clearable
                      v-model="form.phone"
                      placeholder="手机号">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="searchCondition">搜索</el-button>
          </el-form-item>
          <!--                        <el-form-item>-->
          <!--                            <el-button size="small" type="primary" @click="exportT">导出</el-button>-->
          <!--                        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div class="flex1">
      <el-table height="100%" :data="tableData"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号"  prop="account" >
        </el-table-column>
        <el-table-column label="姓名" prop="name">
        </el-table-column>
        <el-table-column label="性别"  >
          <template slot-scope="scope">
            <span v-if="scope.row.sex==0">男</span>
            <span v-if="scope.row.sex==1">女</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号"  prop="phone" >
        </el-table-column>
        <el-table-column label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.userStatus==0" style="color: green">启用</span>
            <span v-if="scope.row.userStatus==1" style="color:red" >禁用</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="上传时间" min-width="140">-->
<!--          <template slot-scope="scope">-->
<!--            {{scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm')}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="审核状态"  width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <span class="" v-if="scope.row.checkState==0">待审核</span>-->
<!--            <span class="font-success" v-if="scope.row.checkState==1">已同意</span>-->
<!--            <span class="font-warning" v-if="scope.row.checkState==2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" >
          <template slot-scope="scope" v-if="scope.row.userStatus==0">
            <el-button type="text" @click="edit(scope.row)"><span style="text-decoration: underline">编辑</span></el-button>
            <el-button type="text" @click="resetP(scope.row)"><span style="text-decoration: underline">重置密码</span></el-button>
            <el-button type="text"  @click="deleteUse(scope.row)"><span style="text-decoration: underline">禁用</span></el-button>
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center global-padd bg-fff">
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="form.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="form.total">
      </el-pagination>
    </div>
    <el-dialog
        :title="form2.userId?'编辑用户':'添加用户'"
        :visible.sync="dialogVisible"
        width="500px"
    >
      <el-form v-model="form2" label-width="150px">
        <el-form-item label="账号：" v-if="!form2.resetPass">
          <el-input size="small"
                    :disabled="form2.userId?true:false"
                    style="width: 180px"
                    clearable
                    v-model="form2.account"
                    placeholder="请输入账号">
          </el-input>
        </el-form-item>
        <el-form-item label="姓名：" v-if="!form2.resetPass">
          <el-input size="small"
                    style="width: 180px"
                    clearable
                    v-model="form2.name"
                    placeholder="请输入姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码：" v-if="!form2.resetPass">
          <el-input size="small"
                    style="width: 180px"
                    clearable
                    v-model="form2.phone"
                    placeholder="请输入手机号码">
          </el-input>
        </el-form-item>
        <el-form-item label="性别：" v-if="!form2.resetPass">
          <el-select size="small"
                     clearable
                     style="width: 180px"
                     v-model="form2.sex">
            <el-option label="男" :value="0" ></el-option>
            <el-option label="女" :value="1" ></el-option>

          </el-select>
        </el-form-item>
        <el-form-item :label="form2.resetPass?'新密码：':'密码：'" v-if="!form2.userId || form2.resetPass">
          <el-input size="small"
                    style="width: 180px"
                    clearable
                    type="password"
                    :show-password="true"
                    v-model="form2.password"
                    :placeholder="form2.resetPass?'请输入新密码':'请输入密码'">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="agreeit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'useManagement',
  data(){
    let _this = this
    return {
      dialogVisible:false,
      form2:{},
      form:{
        keyword:'',
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        total:0
      },
      tableData:[],
    }
  },
  mounted () {
    this.getList()
  },
  watch:{
    dialogVisible(){
      if(this.dialogVisible==false){
        this.form2={}
      }
    }
  },
  methods:{
    deleteUse(data){
      this.$confirm('确认禁用该用户吗？')
      .then(() => {
        this.$http.get('/rest/admin/user/disabled', {userId:data.userId},res => {
          this.$message.success('操作完成！')
        })
        setTimeout(this.getList,1000)
      })
      .catch(() => {});

    },
    resetP(data){
      this.dialogVisible=true
      this.form2.resetPass=true
      this.form2.userId=data.userId
    },
    dialogClose(){
      this.dialogVisible=false
    },
    agreeit(){
      let url
        if(this.form2.resetPass){
          url='/rest/admin/user/password/modify'
        }else{
          url='/rest/admin/user/modify'
        }
        this.$http.get(url, this.form2,res => {
          this.$message.success('提交完成！')
        })
        // this.drawer=false
        this.dialogVisible=false
        setTimeout(this.getList,1000)
      // })
      // .catch(() => {});

    },
    edit(data){
      this.form2=JSON.parse(JSON.stringify(data))
      this.dialogVisible=true
    },
    searchCondition(){
      this.form.page=1
      this.getList()
    },
    handleCurrentChange(a){
      this.form.page=a
      this.getList()
    },

    getList(){
      this.$http.post('/rest/admin/user/list', this.form, res => {
        this.tableData=res.data
        this.form.total=res.total
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/operationManagement/useManagement/index.vue